import { getAuth } from 'firebase/auth'
import { getStorage } from 'firebase/storage'
import { initializeApp, FirebaseOptions } from 'firebase/app'
import { FIREBASE_CONFIG } from './constants'

export const app = initializeApp(getFirebaseConfig())
export const storage = getStorage(app)
export const auth = getAuth(app)

function getFirebaseConfig(): FirebaseOptions {
    switch (process.env.GATSBY_API_URL) {
        case 'https://api.chckup.app/graphql':
            return {
                apiKey: 'AIzaSyBxo9sas58G-9XzStMg6sG8JIkIidNHB78',
                authDomain: 'chckup-server.firebaseapp.com',
                projectId: 'chckup-server',
                storageBucket: 'chckup-server.appspot.com',
                messagingSenderId: '121035766291',
                appId: '1:121035766291:web:f1f8b4436a51cf2448dde6',
                measurementId: 'G-CHZY9FD1PD',
            }
        case 'https://staging.api.chckup.app/graphql':
            return {
                apiKey: 'AIzaSyBdnWXLxCBw6fylMmajMUMBUmaHknLnxCg',
                authDomain: 'chckup-server-staging.firebaseapp.com',
                projectId: 'chckup-server-staging',
                storageBucket: 'chckup-server-staging.appspot.com',
                messagingSenderId: '370833830512',
                appId: '1:370833830512:web:5ab5c559053d374318bab5',
                measurementId: 'G-NKWFDQP8NR',
            }
        case 'https://dev.api.chckup.app/graphql':
            return FIREBASE_CONFIG
        case 'https://test.api.chckup.app':
            return {
                apiKey: 'AIzaSyA95y0c_a8tEjgNKvrKKWwl1mECn6dahbM',
                authDomain: 'chckup-server-test.firebaseapp.com',
                projectId: 'chckup-server-test',
                storageBucket: 'chckup-server-test.appspot.com',
                messagingSenderId: '1054204213605',
                appId: '1:1054204213605:web:1ddc2730c93102bc80c98c',
            }
        case 'http://localhost:4000/graphql':
            return FIREBASE_CONFIG
        case 'http://localhost:4009/graphql':
            return {
                apiKey: 'AIzaSyBxo9sas58G-9XzStMg6sG8JIkIidNHB78',
                authDomain: 'chckup-server.firebaseapp.com',
                projectId: 'chckup-server',
                storageBucket: 'chckup-server.appspot.com',
                messagingSenderId: '121035766291',
                appId: '1:121035766291:web:f1f8b4436a51cf2448dde6',
            }
        case 'http://localhost:4330/graphql':
            return {
                apiKey: 'AIzaSyBxo9sas58G-9XzStMg6sG8JIkIidNHB78',
                authDomain: 'chckup-server.firebaseapp.com',
                projectId: 'chckup-server',
                storageBucket: 'chckup-server.appspot.com',
                messagingSenderId: '121035766291',
                appId: '1:121035766291:web:f1f8b4436a51cf2448dde6',
            }
        default:
            return FIREBASE_CONFIG
    }
}
